/**
 * withI18n
 * HOC for wrapping the provided component with I18nProvider
 */

import React from 'react'

import I18nProvider from './i18n-provider'

export default function withI18n(WrappedComponent) {
  return function LanguagesProviderHOC(props) {
    return (
      <I18nProvider>
        <WrappedComponent {...props} />
      </I18nProvider>
    )
  }
}
